import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      loginState: false
    }
  },
  getters: {
    GETUSER(state){
      state.user = sessionStorage.getItem("user")
      if(state.user){
        return state.user
      }else{
        return JSON.stringify({loginState: false})
      }
    }
  },
  mutations: {
    SETUSER(state, data){
      sessionStorage.setItem('user', JSON.stringify(data))
      state.user = JSON.stringify(data)
    }
  },
  actions: {
    SETUSER(context, data){
      context.commit('SETUSER', data)
    }
  },
  modules: {
  }
})
